import { render } from "./AppQuestionPopUp.vue?vue&type=template&id=b50c1422&scoped=true&ts=true"
import script from "./AppQuestionPopUp.vue?vue&type=script&lang=ts"
export * from "./AppQuestionPopUp.vue?vue&type=script&lang=ts"

import "./AppQuestionPopUp.vue?vue&type=style&index=0&id=b50c1422&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50c1422"]])

export default __exports__